/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agb_Tier_Free_DescInputs */

const en_agb_tier_free_desc = /** @type {(inputs: Agb_Tier_Free_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 AI actions per month, basic resume creation, job tracking.`)
};

const de_agb_tier_free_desc = /** @type {(inputs: Agb_Tier_Free_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 KI-Aktionen pro Monat, einfache Lebenslauf-Erstellung, Job-Tracking.`)
};

const fr_agb_tier_free_desc = /** @type {(inputs: Agb_Tier_Free_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 actions IA par mois, création de CV de base, suivi d'emploi.`)
};

const es_agb_tier_free_desc = /** @type {(inputs: Agb_Tier_Free_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 acciones IA al mes, creación básica de currículum, seguimiento de empleo.`)
};

const it_agb_tier_free_desc = /** @type {(inputs: Agb_Tier_Free_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 azioni AI al mese, creazione curriculum base, tracciamento lavori.`)
};

const nl_agb_tier_free_desc = /** @type {(inputs: Agb_Tier_Free_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 AI-acties per maand, basis CV-creatie, baantracking.`)
};

const pl_agb_tier_free_desc = /** @type {(inputs: Agb_Tier_Free_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 akcji AI miesięcznie, podstawowe tworzenie CV, śledzenie ofert pracy.`)
};

const fi_agb_tier_free_desc = /** @type {(inputs: Agb_Tier_Free_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 AI-toimintoa kuukaudessa, perusansioluettelon luonti, työpaikkojen seuranta.`)
};

const da_agb_tier_free_desc = /** @type {(inputs: Agb_Tier_Free_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 AI-handlinger per måned, grundlæggende CV-oprettelse, jobsporing.`)
};

const sv_agb_tier_free_desc = /** @type {(inputs: Agb_Tier_Free_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 AI-aktioner per månad, grundläggande CV-skapande, jobbspårning.`)
};

/**
* | output |
* | --- |
* | "5 AI actions per month, basic resume creation, job tracking." |
*
* @param {Agb_Tier_Free_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const agb_tier_free_desc = /** @type {((inputs?: Agb_Tier_Free_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agb_Tier_Free_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_agb_tier_free_desc(inputs)
	if (locale === "fr") return fr_agb_tier_free_desc(inputs)
	if (locale === "es") return es_agb_tier_free_desc(inputs)
	if (locale === "it") return it_agb_tier_free_desc(inputs)
	if (locale === "nl") return nl_agb_tier_free_desc(inputs)
	if (locale === "pl") return pl_agb_tier_free_desc(inputs)
	if (locale === "fi") return fi_agb_tier_free_desc(inputs)
	if (locale === "da") return da_agb_tier_free_desc(inputs)
	if (locale === "sv") return sv_agb_tier_free_desc(inputs)
	return en_agb_tier_free_desc(inputs)
});